import axios from 'axios'
export default {
  state: {},
  actions: {
  	//session不存在时处理
  	sessionTimeout(context,data) {
			if(data.msg.indexOf('SessionId')!=-1){
				data.vue.$message({
					type: 'error',
					message: data.msg
				});
				data.vue.$router.push({path: '/',query: ''})
			}
		},
		//处理post上传
		handlePost(context,data) {
			axios.post(data.url, data.data).then(
				(succeed) => {
//					console.log(succeed)			
					if(data.Fn){
						data.Fn(succeed.data)
					}
					
					if(succeed.data.msg!="ok"){
						context.dispatch('sessionTimeout',{'msg': succeed.data.msg, 'vue':data.vue})	
					}					
				}
			).catch(
				(err) => {
					if(sessionStorage.getItem('sessionId') == ""){
						data.vue.$router.push({path: '/', query: ''})	
						data.vue.$message({
							type: 'error',
							message: 'SessionId已经超时'
						});	
					}else{
						data.vue.$message({
							type: 'error',
							message: '数据连接失败'
						});						
					}								
				}
			)
		},
		//处理Get上传
		handleGet(context,data) {
			axios.get(data.url).then(
				(succeed) => {
					data.Fn(succeed.data)
					if(succeed.data.msg!="ok"){
						context.dispatch('sessionTimeout',{'msg': succeed.data.msg, 'vue':data.vue})	
					}
				}
			).catch(
				(error) => {
					if(sessionStorage.getItem('sessionId') == ""){
						data.vue.$router.push({path: '/', query: ''})	
						data.vue.$message({
							type: 'error',
							message: 'SessionId已经超时'
						});	
					}else{
						data.vue.$message({
							type: 'error',
							message: '数据连接失败'
						});						
					}	
				}
			)
		},
  }
}



// WEBPACK FOOTER //
// ./src/store/module/UserModule.js